import React from "react";
import { Button } from "../../components";
import { ClientReportManagementPageSubHeader, FiltersAppliedWarningMessage, ThemedIcon } from "../../components/utilities";
import CreateStandardParagraphModal from "../../features/createstandardparagraphmodal";
import { StandardParagraphFiltersModal } from "../../features/standardparagraphfilters";
import { StandardParagraphFilterProvider, useStandardParagraphFilterContext } from "../../features/standardparagraphfilters/hooks/StandardParagraphFilterContext";
import withProviders from "../../hooks/withProviders";
import StandardParagraphManagementTable from "../../features/standardparagraphmanagementtable";

const StandardParagraphManagementPage = () => {
    const [showCreate, setShowCreate] = React.useState(false);
    const { setShowFilterModal, isFiltersApplied, resetFilter } = useStandardParagraphFilterContext();

    return <>
        <CreateStandardParagraphModal
            show={showCreate}
            onHide={() => setShowCreate(false)}
        />
        <StandardParagraphFiltersModal />
        <ClientReportManagementPageSubHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <React.Fragment>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={resetFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </React.Fragment>
                    )}
                </div>
                <Button className="mx-2" variant="primary" onClick={() => setShowFilterModal(true)}>
                    Filter Paragraphs
                </Button>
            </div>
        </ClientReportManagementPageSubHeader>
        <section className="px-4 my-3 h-100">
            <StandardParagraphManagementTable showCreateModal={() => setShowCreate(true)} />
        </section>
    </>
}

export default withProviders(StandardParagraphFilterProvider)(StandardParagraphManagementPage);